import React, { useEffect, useState } from 'react'
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material'
import Spinner from '../../ui/Spinner'
import {
  getBookedLessonAndProfileStudent,
  cancelBookedLessonByTeacher,
  cancelBookedLessonByTeacherV2
} from '../../../actions/learningScheduleForStudent'
import { confirmBookedLesson } from '../../../actions/teachingScheduleForTeacher'
import { connect } from 'react-redux'
import moment from 'moment'
import { Cancel } from '@mui/icons-material'
import ComplaintAboutBookedLesson from './ComplaintAboutBookedLesson'

const BookedLessonInfo = ({
  getBookedLessonAndProfileStudent,
  match,
  learningScheduleForStudent: { loading, bookedLesson },
  profileStudent: { loadingProfileStudent, profile: profileStudent },
}) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    getBookedLessonAndProfileStudent(match.params.bookedLessonId)

  }, [match.params.bookedLessonId, getBookedLessonAndProfileStudent])

  const isStepOptional = (step) => {
    return step === 1;
  };

  const steps = ['Lesson booked', 'Student complained about the lesson', 'Lesson succeeded'];

  if (bookedLesson && bookedLesson.state === 'Lesson booked' && activeStep !== 0) {
    setActiveStep(0)
  } else if (bookedLesson && bookedLesson.state === 'Student complained about the lesson' && activeStep !== 1) {
    setActiveStep(1)
  } else if (bookedLesson && bookedLesson.state === 'Lesson succeeded' && activeStep !== 2) {
    setActiveStep(2)
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className="container"
      style={{ width: '100%', margin: '0' }}
      spacing={3}
    >
      <Grid item>
        <Typography
          variant="h4"
          style={{ textTransform: 'uppercase', fontWeight: '500' }}
        >
          Lesson's details
        </Typography>
      </Grid>

      <Grid item style={{ marginTop: '1.5em' }}>
        <Card style={{ padding: '1em' }}>
          <CardContent>
            {loading ||
              !bookedLesson ||
              loadingProfileStudent ||
              !profileStudent ? (
              <Spinner />
            ) : (
              <Grid container direction="column" spacing={1}>
                <Grid item style={{ textAlign: 'center' }}>
                  <Typography variant='body1'><strong>Status:</strong></Typography>
                </Grid>

                {bookedLesson && bookedLesson.state === 'Lesson has been canceled by teacher' ? <Grid container justifyContent='center' alignItems='center'>
                  <Grid item>
                    <Cancel size='md' style={{ color: 'red' }} />
                  </Grid>

                  <Grid item>
                    <Typography variant='body1' style={{ color: 'red' }}>Lesson has been canceled by teacher</Typography>
                  </Grid>
                </Grid> : <Grid item style={{ textAlign: 'center', minWidth: '100%' }}>
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      if (isStepOptional(index)) {
                        labelProps.optional = (
                          <Typography variant="caption">Optional</Typography>
                        );
                      }
                      return (
                        <Step key={label} {...stepProps}>
                          <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </Grid>}

                <Grid item>
                  <Typography variant="body1">
                    <strong>Student's name: </strong>
                    {bookedLesson &&
                      bookedLesson.user &&
                      bookedLesson.user.name}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    <strong>Type of lesson: </strong>
                    {bookedLesson &&
                      bookedLesson.lesson &&
                      bookedLesson.lesson.lessonName}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    <strong>Student's email: </strong>
                    {bookedLesson &&
                      bookedLesson.user &&
                      bookedLesson.user.email}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    <strong>Student's Skype ID: </strong>
                    {profileStudent && profileStudent.skypeId}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    <strong>Student's phone number: </strong>
                    {profileStudent && profileStudent.phoneNumber}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    <strong>Lesson's state: </strong>
                    {bookedLesson && bookedLesson.state}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    <strong>Lesson's starting time: </strong>
                    {bookedLesson &&
                      bookedLesson.bookedTime &&
                      bookedLesson.bookedTime[0] &&
                      moment(bookedLesson.bookedTime[0].start)
                        .locale('en')
                        .format('hh:mm A, dddd, MMMM Do YYYY')}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    <strong>Lesson's ending time:</strong>&nbsp;
                    {bookedLesson &&
                      bookedLesson.duration &&
                      bookedLesson.duration === 1800000
                      ? moment(bookedLesson.bookedTime[0].start)
                        .add(30, 'minutes')
                        .locale('en')
                        .format('hh:mm A, dddd, MMMM Do YYYY')
                      : bookedLesson &&
                        bookedLesson.duration &&
                        bookedLesson.duration === 2700000
                        ? moment(bookedLesson.bookedTime[0].start)
                          .add(45, 'minutes')
                          .locale('en')
                          .format('hh:mm A, dddd, MMMM Do YYYY')
                        : bookedLesson && bookedLesson.duration === 3600000
                          ? moment(bookedLesson.bookedTime[0].start)
                            .add(60, 'minutes')
                            .locale('en')
                            .format('hh:mm A, dddd, MMMM Do YYYY')
                          : null}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1"><strong>Is teaching fee paid for teacher yet? </strong>{bookedLesson && bookedLesson.isPaidForTeacher ? 'Yes' : 'No'}</Typography>
                </Grid>

                {bookedLesson && bookedLesson.paidForTeacherDate && <Grid item>
                  <Typography variant="body1"><strong>Paid teaching fee date: </strong>{moment(bookedLesson.paidForTeacherDate).locale('en').format('hh:mm A, dddd, MMMM Do YYYY')}</Typography>
                </Grid>}

              </Grid>
            )}
          </CardContent>
        </Card>
      </Grid>

      {bookedLesson && bookedLesson.complaint && bookedLesson.complaint.content && <ComplaintAboutBookedLesson bookedLesson={bookedLesson} />}
    </Grid>
  );
}

const mapStateToProps = (state) => ({
  learningScheduleForStudent: state.learningScheduleForStudent,
  profileStudent: state.profileStudent,
})

export default connect(mapStateToProps, {
  confirmBookedLesson,
  cancelBookedLessonByTeacher,
  getBookedLessonAndProfileStudent,
  cancelBookedLessonByTeacherV2
})(BookedLessonInfo)
